import { type ReactNode } from 'react'

export default function StickyFooter({ children }: { children: ReactNode }) {
  return (
    <div className="from-hw-cream via-hw-cream to-hw-cream/0 sticky bottom-0 z-10 mt-auto bg-gradient-to-t pt-6 pb-6">
      {children}
    </div>
  )
}
